import React, { memo, useEffect, useState, useMemo, useRef } from 'react';
import ReactDOM from 'react-dom';
import useInterval from '@use-it/interval';
import Scrollbars from 'react-custom-scrollbars';
import styled from 'styled-components';

import { Profile } from '../components';
import {
  MPLFNotifications,
  NotificationDetail,
  MPLFBadgeAllClear,
  MPLFRead,
  MPLFReadAll,
  MapGroupGetInvitations,
  MapGroupUpdateInvitation,
} from '../modules/API';
import Cookies from '../modules/Cookies';
import { NativeClearNotificationsBadge } from '../modules/Native';
import { sleep } from '../modules/Utils';
import { resolveLang } from 'common/handleLocale';

let onNotiModalOpen = () => {};

let badgeCountCache = 0;
const setBadge = async (badge = 0) => {
  badgeCountCache = badge;
  $('.notiCountBadge').text(badge);
  $('.notiCountBadge')[badge ? 'show' : 'hide']();

  if (!badge) {
    NativeClearNotificationsBadge();
  }

  // NaviProfile is loaded async
  while ($('.naviNotiCountBadge').length < 1) {
    await sleep(300);
  }

  $('.naviNotiCountBadge').text(badge);
  $('.naviNotiCountBadge')[badge ? 'show' : 'hide']();
};
$(document).on('click', '.clearBadgeCount', async () => {
  if (badgeCountCache) {
    await MPLFBadgeAllClear({ session: Cookies.get('session') }).catch((e) => {
      console.log(e);
      console.log('MPLFBadgeAllClearError');
    });
    setBadge();
  }

  onNotiModalOpen();
});

/**
 * @type {{
 *  senders: {
 *    [id: string]: {
 *      _id: string;
 *      nickname: string;
 *      icon_url: string;
 *    }
 *  },
 *  maps: {
 *    [id: string]: {
 *      _id: string;
 *      title: string;
 *      lang: {
 *        [locale: string] : {
 *          title: string;
 *        }
 *      }
 *    }
 *  },
 *  spots: {
 *    [id: string]: {
 *      _id: string;
 *      title: string;
 *      map_id: string;
 *      lang: {
 *        [locale: string] : {
 *          title: string;
 *        }
 *      }
 *    }
 *  },
 *  dialies: {
 *    [id: string]: {
 *      spot_id: string;
 *    }
 *  },
 *  mapGroups: {
 *    [map_id: string]: {
 *      _id: string;
 *      map_id: string;
 *      account_id: string;
 *      accepted: '0' | '1';
 *      map: {
 *        title: string;
 *        lang: {};
 *        image_id: string;
 *      };
 *      account: {
 *        nickname: string;
 *        icon_url: string;
 *      };
 *    }
 *  }
 * }}
 */
const detailDic = {
  senders: {},
  maps: {},
  spots: {},
  dialies: {},
  mapGroups: {},
};

/**
 * @param {moment.Moment} date
 */
const parseRelativeAndCalendarTime = (date) => {
  const today = window.moment();

  if (today.diff(date, 'h') < 22 * 1) {
    return date.fromNow();
  }

  if (today.diff(date, 'h') < 22 * 6) {
    return date.calendar();
  }

  return date.format('LL');
};

const normalizeNotificationDataText = (text) =>
  String(text || '')
    .replace(/\+/g, ' ')
    .replace(/\[newline\]/g, '\n')
    .replace(/[\x00-\x1F\x7F]/g, '');

const parseNotificationData = (rawData) => {
  if (!rawData) {
    return null;
  }

  if (typeof rawData === 'object') {
    return rawData;
  }

  const tryParse = (text) => {
    if (typeof text !== 'string') {
      return null;
    }

    try {
      return JSON.parse(normalizeNotificationDataText(text));
    } catch (error) {
      return null;
    }
  };

  try {
    const decodedData = decodeURIComponent(atob(rawData));
    const parsedDecodedData = tryParse(decodedData);
    if (parsedDecodedData) {
      return parsedDecodedData;
    }
  } catch (error) {
    // fallback to raw JSON parsing
  }

  return tryParse(rawData);
};

let offset = 0;
const limit = 20;
let fetching = false;

const NotiModalComponent = memo(() => {
  const [hasMore, setHasMore] = useState(true);
  const [notiDic, setNotiDic] = useState({});
  const notiList = useMemo(
    () =>
      window._.chain(notiDic)
        .map((noti) => noti)
        .orderBy(['created_at', 'id'], ['desc', 'desc'])
        .valueOf(),
    [notiDic]
  );
  const [submitting, setSubmitting] = useState(false);
  const [mapGroups, setMapGroups] = useState(detailDic.mapGroups);
  const [configNotify, setconfigNotify] = useState({notification_timer_coefficient:400,notification_timer:16000});
  /**
   * @type {React.MutableRefObject<Scrollbars | null>}
   */
  const scrollbarRef = useRef(null);
  let rand = Math.floor(Math.random() * 10);
  let timer = configNotify.notification_timer_coefficient * rand  + configNotify.notification_timer;
  useInterval(async () => {
    const { badge } = await MPLFNotifications({
      offset: 0,
      limit: 0,
      session: Cookies.get('session') || '',
    });

    if (badgeCountCache !== badge) {
      // has new badge - reload all notifications
      offset = 0;
      setHasMore(true);
      setNotiDic({});
      fetchMapGroups();
      fetchNotifications();
    }
  }, timer);

  useEffect(() => {
    const innerEffect = async () => {
      checkNotification();
      fetchMapGroups();
      fetchNotifications();
    };
    innerEffect();
  }, []);

  useEffect(() => {
    if ($('#NotiModal').is(':visible')) {
      checkScrollPosition();
    }
  }, [notiDic]);

  const checkNotification = async () => {
    await $.getJSON( window.location.origin + '/js/config/mplfNotification.json', {
      format: "json"
    })
      .done(function( data ) {
        if ( typeof data.notification_timer !== 'undefined' && typeof data.notification_timer_coefficient !== 'undefined') {
          setconfigNotify(data);
        }
      }).catch(() => false);
  };

  const checkScrollPosition = () => {
    if (!scrollbarRef.current) {
      return;
    }

    const { scrollTop, scrollHeight } = scrollbarRef.current.getValues();
    const clientHeight = scrollbarRef.current.getClientHeight();
    if (scrollHeight - clientHeight - scrollTop < 100) {
      fetchNotifications();
    }
  };
  onNotiModalOpen = checkScrollPosition;

  const fetchMapGroups = async () => {
    const mapGroupsInvites = await MapGroupGetInvitations({
      session: Cookies.get('session') || '',
      locale: window.hlocale,
    }).catch(() => {});
    if (mapGroupsInvites) {
      mapGroupsInvites.forEach((mapGroup) => {
        mapGroups[mapGroup.map_id] = mapGroup;
      });

      setMapGroups({ ...mapGroups });
    }
  };

  const fetchNotifications = async () => {
    if (fetching || !hasMore) {
      return;
    }

    fetching = true;

    try {
      const { badge, notifications = {} } = await MPLFNotifications({
        offset,
        limit,
        session: Cookies.get('session') || '',
      });

      setBadge(badge);
      offset += limit;

      const ids = Object.keys(notifications);
      if (ids.length < limit) {
        setHasMore(false);
      }

      /**
       * @type {{
       *  sender_ids: string[];
       *  map_ids: string[];
       *  spot_ids: string[];
       *  dialy_ids: string[];
       * }}
       */
      const allIds = {
        sender_ids: [],
        map_ids: [],
        spot_ids: [],
        dialy_ids: [],
      };

      const tmpNotis = ids.map((id) => {
        /** @type {MplfNotificationsData | null} */
        const data = parseNotificationData(notifications[id].data);
        if (!data) {
          return undefined;
        }

        const { sender, map_id, spot_id, dialy_id } = data;
        if (map_id) {
          if (!detailDic.maps[map_id]) {
            allIds.map_ids.push(map_id);
          }
        } else if (spot_id) {
          if (!detailDic.spots[spot_id]) {
            allIds.spot_ids.push(spot_id);
          }
        } else if (dialy_id) {
          if (!detailDic.dialies[dialy_id]) {
            allIds.dialy_ids.push(dialy_id);
          }
        }

        if (!detailDic.senders[sender]) {
          allIds.sender_ids.push(sender);
        }

        return {
          id,
          ...notifications[id],
          data,
        };
      });

      /** @type {{[key:string]: NonNullable<typeof tmpNotis[0]>}} */
      const newNotis = {};
      tmpNotis.forEach((obj) => {
        if (obj) {
          newNotis[obj.id] = obj;
        }
      });

      allIds.sender_ids = window._.uniq(allIds.sender_ids);
      allIds.map_ids = window._.uniq(allIds.map_ids);
      allIds.spot_ids = window._.uniq(allIds.spot_ids);
      allIds.dialy_ids = window._.uniq(allIds.dialy_ids);

      if (
        allIds.sender_ids.length ||
        allIds.map_ids.length ||
        allIds.spot_ids.length ||
        allIds.dialy_ids.length
      ) {
        const detailResult = await NotificationDetail({
          session: Cookies.get('session'),
          locale: window.hlocale,
          ...allIds,
        });

        window._.forEach(detailResult, (collection, key) => {
          collection.forEach((obj) => {
            detailDic[key][obj._id] = obj;
          });
        });
      }

      setNotiDic({
        ...notiDic,
        ...newNotis,
      });
    } catch (e) {
      console.log(e);
      console.log('MPLFNotificationsError');
    }

    fetching = false;
  };

  const openNoti = (selectedId) => async (e) => {
    e.preventDefault();
    const {
      id,
      open_at,
      data: { dialy_id, spot_id, map_id },
    } = notiDic[selectedId] || {};

    $('#NotiModal').addClass('freeze');

    try {
      if (!open_at) {
        await MPLFRead({
          session: Cookies.get('session'),
          notification_id: id,
        });
      }

      let url = '/';

      if (map_id) {
        url = `/maps/archive/${map_id}`;
      } else if (spot_id) {
        url = `/maps/archive/${detailDic.spots[spot_id].map_id}/wall/spot-list/${spot_id}`;
      } else if (dialy_id) {
        url = `/maps/archive/${
          detailDic.spots[detailDic.dialies[dialy_id].spot_id].map_id
        }/wall/timeline/?post=${dialy_id}`;
      }

      window.location.href = url;
    } catch (error) {
      console.log(error);
      console.log('OpenNotiError');
      resolveLang('エラーが発生しました。');
      $('#NotiModal').removeClass('freeze');
    }
  };

  /**
   * replyInvitation
   * @param {string} mapId
   * @param {'accept' | 'decline'} status
   * @param {string} id
   */
  const replyInvitation = (mapId, status, id) => async () => {
    setSubmitting(true);

    try {
      await MapGroupUpdateInvitation({
        session: Cookies.get('session') || '',
        map_id: mapId,
        status,
        locale: window.hlocale,
      });

      MPLFRead({
        session: Cookies.get('session'),
        notification_id: id,
      }).catch((error) => {
        console.log(error);
      });

      if (status === 'accept') {
        mapGroups[mapId] = {
          ...mapGroups[mapId],
          accepted: '1',
        };
      } else {
        delete mapGroups[mapId];
      }

      if (status === 'accept') {
        // update My Map New
        window.APIGetMyMaps({
          htmlTemplate: 'myMapListInnerTemplate',
          force: 1,
        });
      }
      setMapGroups({ ...mapGroups });
    } catch (error) {
      if (error && error.responseJSON && error.responseJSON.message) {
        alert(error.responseJSON.message);
      }
    }

    setSubmitting(false);
  };

  const renderNotiItems = () => {
    const shownInvitedMaps = [];
    return notiList.map((notiObj) => {
      const { id, openUrl, openKey, data, open_at, created_at } = notiObj;

      if (!data) {
        return null;
      }

      const { type, sender, dialy_id, spot_id, map_id, infomation, subject } = data;

      // nickname
      //if (!detailDic.senders[sender]) {
      //  return null;
      //}

      if (type === 'infomation') {

      //console.log(data);
      //console.log('subject = ' + data.subject);
      //console.log('body = ' + data.infomation);

        const { nickname, icon_url } = detailDic.senders[sender];
        let profileImage = icon_url || '';
        if (profileImage) {
          profileImage = window.isUrl(profileImage)
          ? profileImage
          : `https://s3-ap-northeast-1.amazonaws.com/s3.mplf.net/${profileImage}%3Fsize%3D200`;
        }

      //        mapTitle = detailDic.maps[map_id].title;

      //              style={{
      //                backgroundImage: `url(${profileImage})`,
      //              }}

        return (
        <a
          key={id}
          className={`notiListItem ${open_at ? '' : 'unread'}`}
          href={`/tools/admin/infomation/${openKey}/view`}
        >
          <div>
            <i
              className="isBackground"
            />
          </div>
          <div>
            <p
              dangerouslySetInnerHTML={{
                __html: '<strong>' + data.subject + '</strong><br/>' + notiObj.message,
              }}
            />
            <span>
              {parseRelativeAndCalendarTime(moment.utc(created_at).local())}
            </span>
          </div>
        </a>
        );
      }

      if (type === 'mapInvite') {
        if (!mapGroups[map_id] || shownInvitedMaps.includes(map_id)) {
          return null;
        }

        shownInvitedMaps.push(map_id);

        const { nickname, icon_url } = detailDic.senders[sender];
        const {
          accepted: accepted_flag,
          map: { image_id },
        } = mapGroups[map_id];

        const accepted = accepted_flag === '1';

        const messageKey = accepted ? 'mapInviteAccepted' : 'mapInvite';
        const message = nickname
          ? notiTemplates.messages[messageKey].hasName
          : notiTemplates.messages[messageKey].noName;

        return (
          <MapInviteDiv
            onClick={() => {
              if (accepted) {
                window.location.href = `/maps/archive/${map_id}`;
              }
            }}
            className={`notiListItem ${accepted ? '' : 'unread'}`}
            key={id}
            imageId={
              image_id &&
              `https://s3-ap-northeast-1.amazonaws.com/s3.mplf.net/${image_id}%3Fsize%3D200`
            }
          >
            <div>
              <div />
              <p
                dangerouslySetInnerHTML={{
                  __html: resolveLang(message, {
                    nickname,
                    mapTitle: window.resolveTranslated(
                      mapGroups[map_id].map,
                      'title'
                    ),
                  }),
                }}
              />
            </div>
            <div>
              <Profile iconSize={30} imageId={icon_url} name={nickname} />
              {!accepted && (
                <div>
                  <button
                    className="btnRed"
                    onClick={replyInvitation(map_id, 'decline', id)}
                    disabled={submitting}
                  >
                    {resolveLang('断る')}
                  </button>
                  <button
                    className="btnBlue"
                    onClick={replyInvitation(map_id, 'accept', id)}
                    disabled={submitting}
                  >
                    {resolveLang('受ける')}
                  </button>
                </div>
              )}
            </div>
          </MapInviteDiv>
        );
      }

      const { nickname, icon_url } = (detailDic.senders[sender] != undefined) ? detailDic.senders[sender] : '';
      let docType = '';
      let title = '';
      let spotTitle = '';
      let mapTitle = '';

      if (dialy_id) {
        if (!detailDic.dialies[dialy_id]) {
          return null;
        }

        const dialy = detailDic.dialies[dialy_id];

        if (!detailDic.spots[dialy.spot_id]) {
          return null;
        }
        title = spotTitle = window.resolveTranslated(
          detailDic.spots[dialy.spot_id],
          'title'
        );
        docType = resolveLang('記事');
      }

      if (spot_id) {
        if (!detailDic.spots[spot_id]) {
          return null;
        }
        const spot = detailDic.spots[spot_id];
        title = spotTitle = window.resolveTranslated(spot, 'title');

        if (!detailDic.maps[spot.map_id]) {
          return null;
        }
        mapTitle = window.resolveTranslated(
          detailDic.maps[spot.map_id],
          'title'
        );
        docType = resolveLang('スポット');
      }

      if (map_id) {
        if (!detailDic.maps[map_id]) {
          return null;
        }
        title = mapTitle = window.resolveTranslated(
          detailDic.maps[map_id],
          'title'
        );
        docType = resolveLang('マップ');
      }

      if (!notiTemplates.messages[type]) {
        return null;
      }

      let message = nickname
        ? notiTemplates.messages[type].hasName
        : notiTemplates.messages[type].noName;

      message = resolveLang(message, {
        nickname,
        docType,
        title,
        spotTitle,
        mapTitle,
      });

      let profileImage = icon_url || '';
      if (profileImage) {
        profileImage = window.isUrl(profileImage)
          ? profileImage
          : `https://s3-ap-northeast-1.amazonaws.com/s3.mplf.net/${profileImage}%3Fsize%3D200`;
      }

      return (
        <a
          key={id}
          className={`notiListItem ${open_at ? '' : 'unread'}`}
          href="/"
          onClick={openNoti(id)}
        >
          <div>
            <i
              className="isBackground"
              style={{
                backgroundImage: `url(${profileImage})`,
              }}
            />
          </div>
          <div>
            <p
              dangerouslySetInnerHTML={{
                __html: message,
              }}
            />
            <span>
              {parseRelativeAndCalendarTime(moment.utc(created_at).local())}
            </span>
          </div>
        </a>
      );
    }).filter((obj) => !!obj);
  };

  const notiItems = renderNotiItems();

  return (
    <div className="modalInner">
      <div className="modalHead">
        <span
          onClick={() => {
            const hasUnreadNoti = window._.find(
              notiDic,
              ({ open_at }) => !open_at
            );

            if (!hasUnreadNoti) {
              return;
            }

            MPLFReadAll({ session: Cookies.get('session') }).catch((e) => {
              console.log(e);
              console.log('MPLFReadAllError');
            });

            window._.forEach(notiDic, (noti) => {
              if (!noti.open_at) {
                noti.open_at = moment().format('YYYY-MM-DD HH-mm-ss');
              }
            });

            setNotiDic({
              ...notiDic,
            });
          }}
        >
          {resolveLang('すべて既読にする')}
        </span>
        <p>{resolveLang('お知らせ')}</p>
        <i className="closeModal" />
      </div>
      <div className="modalBody">
        <Scrollbars
          autoHide
          style={{ height: '100%' }}
          onScroll={checkScrollPosition}
          ref={scrollbarRef}
        >
          <div className="notiListContainer">
            {notiItems}

            {hasMore && (
              <div className="skLoadingContainer">
                <div className="sk-fading-circle">
                  <div className="sk-circle1 sk-circle" />
                  <div className="sk-circle2 sk-circle" />
                  <div className="sk-circle3 sk-circle" />
                  <div className="sk-circle4 sk-circle" />
                  <div className="sk-circle5 sk-circle" />
                  <div className="sk-circle6 sk-circle" />
                  <div className="sk-circle7 sk-circle" />
                  <div className="sk-circle8 sk-circle" />
                  <div className="sk-circle9 sk-circle" />
                  <div className="sk-circle10 sk-circle" />
                  <div className="sk-circle11 sk-circle" />
                  <div className="sk-circle12 sk-circle" />
                </div>
              </div>
            )}

            {!hasMore && !notiItems.length && (
              <p>{resolveLang('お知らせがありません。')}</p>
            )}
          </div>
        </Scrollbars>
      </div>
      <div className="skFadingCircleContainer">
        <div className="sk-fading-circle">
          <div className="sk-circle1 sk-circle" />
          <div className="sk-circle2 sk-circle" />
          <div className="sk-circle3 sk-circle" />
          <div className="sk-circle4 sk-circle" />
          <div className="sk-circle5 sk-circle" />
          <div className="sk-circle6 sk-circle" />
          <div className="sk-circle7 sk-circle" />
          <div className="sk-circle8 sk-circle" />
          <div className="sk-circle9 sk-circle" />
          <div className="sk-circle10 sk-circle" />
          <div className="sk-circle11 sk-circle" />
          <div className="sk-circle12 sk-circle" />
        </div>
      </div>
    </div>
  );
});

if (Cookies.get('session')) {
  ReactDOM.render(<NotiModalComponent />, document.getElementById('NotiModal'));

  setTimeout(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.get('open_noti_modal')) {
      $('.clearBadgeCount').trigger('click');
    }
  }, 1000);
}

const notiTemplates = {
  messages: {
    good: {
      hasName:
        '<strong>{{nickname}}</strong>さんが<strong>{{title}}</strong>{{docType}}に<strong>いいね！</strong>しました。',
      noName:
        '<strong>{{title}}</strong>{{docType}}が<strong>いいね！</strong>されました。',
    },
    follow: {
      hasName:
        '<strong>{{nickname}}</strong>さんが<strong>{{title}}</strong>{{docType}}を<strong>フォロー</strong>しました。',
      noName:
        '<strong>{{title}}</strong>{{docType}}が<strong>フォロー</strong>されました。',
    },
    comment: {
      hasName:
        '<strong>{{nickname}}</strong>さんが<strong>{{title}}</strong>{{docType}}に<strong>コメント</strong>しました。',
      noName:
        '<strong>{{title}}</strong>{{docType}}に新しい<strong>コメント</strong>があります。',
    },
    createDialy: {
      hasName:
        '<strong>{{nickname}}</strong>さんが<strong>{{spotTitle}}</strong>スポットにチェックインしました。',
      noName:
        '<strong>{{spotTitle}}</strong>スポットにチェックインがありました。',
    },
    createSpot: {
      hasName:
        '<strong>{{nickname}}</strong>さんが<strong>{{mapTitle}}</strong>マップに<strong>{{spotTitle}}</strong>スポットを追加しました。',
      noName:
        '<strong>{{mapTitle}}</strong>マップに<strong>{{spotTitle}}</strong>スポットが追加されました。',
    },
    mapInvite: {
      hasName:
        '<strong>{{nickname}}</strong>さんが<strong>{{mapTitle}}</strong>マップに招待しています。',
      noName: '<strong>{{mapTitle}}</strong>マップに招待しています。',
    },
    mapInviteAccepted: {
      hasName:
        '<strong>{{nickname}}</strong>さんから<strong>{{mapTitle}}</strong>マップの招待を受けました。',
      noName: '<strong>{{mapTitle}}</strong>マップの招待を受けました。',
    },
    createMission: {
      hasName:
        '<strong>{{spotTitle}}</strong>スポットに新しいミッションが開始しました。',
      noName:
        '<strong>{{spotTitle}}</strong>スポットに新しいミッションが開始しました。',
    },
  },
};

//#region styles
const MapInviteDiv = styled.div`
  display: block;
  cursor: pointer;

  &.unread {
    cursor: default;
    &:hover {
      opacity: 1;
    }
  }

  & > {
    div:first-child {
      background: none;
      width: auto !important;
      height: auto !important;
      display: flex;
      border-radius: 0;
      align-items: center;

      & > div {
        background: ${(props) =>
            props.imageId ? `url(${props.imageId})` : '#aaa'}
          no-repeat;
        width: 100px;
        height: 60px;
        border-radius: 8px;
      }

      & > p {
        padding-left: 8px;
        line-height: 1.5;
        flex: 1;
      }
    }

    div:last-child {
      padding-top: 8px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;

      & > div:first-child {
        min-width: 0;
      }

      & > div:last-child {
        flex: 1;
        display: flex;
        justify-content: flex-end;

        button {
          margin-left: 8px;
        }
      }
    }
  }
`;
//#endregion
